function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { defaultConverter as t, notEqual as e } from "../reactive-element.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

var o = {
  attribute: !0,
  type: String,
  converter: t,
  reflect: !1,
  hasChanged: e
},
    r = function r() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : o;
  var e = arguments.length > 1 ? arguments[1] : undefined;
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var n = r.kind,
      i = r.metadata;
  var s = globalThis.litPropertyMetadata.get(i);

  if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map()), s.set(r.name, t), "accessor" === n) {
    var _o = r.name;
    return {
      set: function set(r) {
        var n = e.get.call(this);
        e.set.call(this, r), this.requestUpdate(_o, n, t);
      },
      init: function init(e) {
        return void 0 !== e && this.P(_o, void 0, t), e;
      }
    };
  }

  if ("setter" === n) {
    var _o2 = r.name;
    return function (r) {
      var n = this[_o2];
      e.call(this, r), this.requestUpdate(_o2, n, t);
    };
  }

  throw Error("Unsupported decorator location: " + n);
};

function n(t) {
  return function (e, o) {
    return "object" == _typeof(o) ? r(t, e, o) : function (t, e, o) {
      var r = e.hasOwnProperty(o);
      return e.constructor.createProperty(o, r ? _objectSpread(_objectSpread({}, t), {}, {
        wrapped: !0
      }) : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
    }(t, e, o);
  };
}

export { n as property, r as standardProperty };